/**
 * Espelha eventos do Pixel (turmas) na Conversions API.
 */

import { getMarketingAttributionPayload } from '@/services/marketingAttribution';

const PIXEL_SCOPE = 'turmas';

function apiBase() {
    const base = String(import.meta.env.VITE_APP_REST_API_V1 || '').replace(/\/$/, '');
    return base || '';
}

/**
 * @param {{
 *   eventName: 'ViewContent' | 'InitiateCheckout',
 *   eventId: string,
 *   customData?: Record<string, unknown>,
 *   email?: string | null,
 *   phone?: string | null,
 * }} params
 */
export function mirrorMetaEventToCapi({
    eventName,
    eventId,
    customData = {},
    email = null,
    phone = null,
}) {
    if (typeof window === 'undefined' || !eventId || !eventName) {
        return;
    }

    const base = apiBase();
    if (!base) return;

    const attribution = getMarketingAttributionPayload();
    const body = {
        pixel: PIXEL_SCOPE,
        event_name: eventName,
        event_id: String(eventId),
        event_source_url: window.location.href,
        event_time: Math.floor(Date.now() / 1000),
        custom_data: customData,
    };

    if (attribution.fbp) body.fbp = attribution.fbp;
    if (attribution.fbc) body.fbc = attribution.fbc;
    if (email) body.email = String(email).trim().toLowerCase();
    if (phone) body.phone = String(phone).replace(/\D/g, '');

    const url = `${base}/api/v1/public/meta/events`;
    const payload = JSON.stringify(body);

    try {
        if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
            const blob = new Blob([payload], { type: 'application/json' });
            if (navigator.sendBeacon(url, blob)) {
                return;
            }
        }
    } catch {
        // fallback fetch
    }

    try {
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: payload,
            keepalive: true,
            credentials: 'omit',
        }).catch(() => {});
    } catch {
        // silencioso
    }
}
